'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {

	return {
		error: function(msg) {
			growl(msg.data.error, 1);
		},
		product: $resource(
			apiConfig.$get().apiUrl + '/product',
			{
				supplierGroupId:'@supplier_company_id',
				articleNumber:'@sku'
			},
			{
				query: {
					isArray: false,
				}
			}
		)
	}
}
